import { AxiosInstance } from 'axios';

import { InventoryAPIApiFactory as old } from '@cast/openapi';
import {
  CloudAssetAPIApiFactory,
  CloudAssetIntegrationsAPIApiFactory,
} from '@cast/openapi-inventory';

import { AXIOS_CONFIGURATION } from '../constants';

export const InventoryApiAdapter = (client: AxiosInstance) => {
  const oldGeneratedApi = old(AXIOS_CONFIGURATION, '', client);

  const generatedApi = CloudAssetIntegrationsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const generatedApiCouldAsset = CloudAssetAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listRegions: oldGeneratedApi.inventoryAPIListRegions,
    listInstanceTypes: oldGeneratedApi.inventoryAPIListInstanceTypeNames,
    getAssetDiscoveryCommand:
      generatedApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand,
    getAssetListClusters: generatedApiCouldAsset.cloudAssetAPIListClusters,
    getReliabilityDataCommand:
      generatedApiCouldAsset.cloudAssetAPIGetReliabilityDataCommand,
    listCloudAssetIntegrations:
      generatedApi.cloudAssetIntegrationsAPIListCloudAssetIntegrations,
    deleteCloudAssetIntegration:
      generatedApi.cloudAssetIntegrationsAPIDeleteCloudAssetIntegration,
    updateCloudAssetIntegration:
      generatedApi.cloudAssetIntegrationsAPIUpdateCloudAssetIntegration,
    getCloudAssetIntegrationCleanupCommand:
      generatedApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand,
    getCloudAssetIntegrationSyncReport:
      generatedApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport,
  };
};
